import { render, staticRenderFns } from "./CourceModelsDays.vue?vue&type=template&id=41e07ab5&scoped=true"
import script from "./CourceModelsDays.vue?vue&type=script&lang=js"
export * from "./CourceModelsDays.vue?vue&type=script&lang=js"
import style0 from "./CourceModelsDays.vue?vue&type=style&index=0&id=41e07ab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e07ab5",
  null
  
)

export default component.exports